package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetPlayerResponse(
    val data: List<GetPlayerData>,
)
@Serializable
data class GetPlayerData(
    val age: String = "",
    val coachName: String = "",
    val count: Long = 0,
    val mentions: String = "",
    val email: String = "",
    val firstName: String = "",
    val imageUrl: String = "",
    val lastName: String = "",
    val position: String = "",
    var rating: Double = 0.0,
    var team: String = "",
    @SerialName("userID")
    val userId: String = "",
    val uid: String = "",
    val teams: List<TeamsObject> = emptyList(),
    val type: String = "",
    val verificationCode: String = ""
)


